/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Code indicating the type of error.
*/
export enum ErrorCode {
  InternalJobError = 'INTERNAL_JOB_ERROR',
  JobCanceledError = 'JOB_CANCELED_ERROR',
  FailedToGetResourceInformation = 'FAILED_TO_GET_RESOURCE_INFORMATION',
  ResourceIsTerminated = 'RESOURCE_IS_TERMINATED',
  InvalidResourceState = 'INVALID_RESOURCE_STATE',
  InvalidResourceConfiguration = 'INVALID_RESOURCE_CONFIGURATION',
  ResourceConflict = 'RESOURCE_CONFLICT',
  UnsupportedOperationOnResource = 'UNSUPPORTED_OPERATION_ON_RESOURCE',
  FailedToCreateResource = 'FAILED_TO_CREATE_RESOURCE',
  FailedToStartResource = 'FAILED_TO_START_RESOURCE',
  FailedToStopResource = 'FAILED_TO_STOP_RESOURCE',
  FailedToGetStorageInformation = 'FAILED_TO_GET_STORAGE_INFORMATION',
  FailedToCreateStorage = 'FAILED_TO_CREATE_STORAGE',
  FailedToDeleteStorage = 'FAILED_TO_DELETE_STORAGE',
  FailedToAttachStorage = 'FAILED_TO_ATTACH_STORAGE',
  FailedToDetachStorage = 'FAILED_TO_DETACH_STORAGE',
  FailedToCreateImage = 'FAILED_TO_CREATE_IMAGE',
  FailedToGetSnapshotInformation = 'FAILED_TO_GET_SNAPSHOT_INFORMATION',
  FailedToTakeSnapshot = 'FAILED_TO_TAKE_SNAPSHOT',
  FailedToUseSnapshot = 'FAILED_TO_USE_SNAPSHOT',
  FailedToDeleteSnapshot = 'FAILED_TO_DELETE_SNAPSHOT',
  SnapshotQuotaExceeded = 'SNAPSHOT_QUOTA_EXCEEDED',
  ResourceUsageQuotaExceeded = 'RESOURCE_USAGE_QUOTA_EXCEEDED',
  AuthenticationFailure = 'AUTHENTICATION_FAILURE',
  InvalidAccountConfiguration = 'INVALID_ACCOUNT_CONFIGURATION',
  InvalidVaultConfiguration = 'INVALID_VAULT_CONFIGURATION',
  InvalidInputParameters = 'INVALID_INPUT_PARAMETERS',
  TooManyRequests = 'TOO_MANY_REQUESTS',
  BackupConflict = 'BACKUP_CONFLICT',
  FailedToRunQuery = 'FAILED_TO_RUN_QUERY',
  OperationDeniedByConfiguration = 'OPERATION_DENIED_BY_CONFIGURATION',
  InsufficientEncryptionPermissions = 'INSUFFICIENT_ENCRYPTION_PERMISSIONS'
}
